export default [
  {
    content: "안전인증 및 안전검사 수검 여부 확인",
    isChecked: "",
  },
  {
    content: "안전문(게이트가드)설치 여부",
    isChecked: "",
  },
  {
    content: "안전문 개방 시 동작 정지되도록 연동장치 정상작동 여부 확인",
    isChecked: "",
  },
  {
    content: "가열 실린더 히터에 방호덮개 부착 여부",
    isChecked: "",
  },
  {
    content: "수리·점검·이물질 제거 등 작업 시 전원 차단 후 작업",
    isChecked: "",
  },
  {
    content: "수리·점검·이물질 제거 등 작업 시 잠금장치 및 “작업중” 표시",
    isChecked: "",
  },
  {
    content: "비상정지버튼 정상 작동 유무",
    isChecked: "",
  },
  {
    content: "금형 부착, 해체 또는 조정 작업 시 작업절차 준수",
    isChecked: "",
  },
  {
    content: "바렐 및 노즐부위 노즐충전부에 절연캡 또는 덮개 설치 상태 확인",
    isChecked: "",
  },
  {
    content: "호퍼 내 연료 투입장소에 안전난간 설치상태 확인 (2m이상 고소 작업 시)",
    isChecked: "",
  },
];
